import viewItemGroup from '../../src/components/itemgroup/pages/view';

export default [
    {
        path:':id/:title',
        component: viewItemGroup
    }
]